import { FacebookOutlined, Link, Mail } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from '@mui/material'

export default function ShareDialogComponent(
    { openShareDialog, handleShareDialogClose, copyPhotoUrlToClipboard, shareOnFacebook, shareViaEmail }: any) {
    return (
        <>
            <Dialog open={openShareDialog} onClose={handleShareDialogClose}>
                <DialogTitle>Share Photo</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Choose a platform to share the photo:
                    </DialogContentText>
                    <Box display="flex" justifyContent="space-evenly">
                        <Tooltip title="Copy link to clipboard">
                            <IconButton onClick={copyPhotoUrlToClipboard} aria-label="copy">
                                <Link color='primary' />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Share on Facebook">
                            <IconButton
                                onClick={shareOnFacebook}
                                aria-label="facebook">
                                <FacebookOutlined color="info" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Share on Email">
                            <IconButton
                                onClick={shareViaEmail}
                                aria-label="email">
                                <Mail color='error' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleShareDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
